import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Integration } from './models/integration.model';

@Injectable({
    providedIn: 'root'
})
export class IntegrationService {
    private apiUrl = `${environment.apiUrl}/integrations`;

    constructor(private http: HttpClient) { }

    getIntegrations(): Observable<Integration[]> {
        return this.http.get<Integration[]>(this.apiUrl);
    }
}
